import React from 'react';
import Section from '../ui/Section';
import Button from '../ui/Button';
import { motion } from 'framer-motion';

const BookSection = () => {
  return (
    <Section bg="white" className="py-24">
      <div className="max-w-5xl mx-auto bg-brand-navy rounded-[3rem] p-8 md:p-16 text-white overflow-hidden relative">
        <div className="absolute top-0 right-0 w-64 h-64 bg-brand-teal/10 rounded-full blur-3xl"></div>
        
        <div className="flex flex-col md:flex-row items-center gap-12 relative z-10">
          <div className="w-full md:w-1/3 flex justify-center">
            <motion.img 
              initial={{ rotate: -5, opacity: 0 }}
              whileInView={{ rotate: 0, opacity: 1 }}
              viewport={{ once: true }}
              src="https://media-manager-c.questera.ai/greta-media/7c98abf852f963e06195176deed57bb9c81b4f53d205af5ca5b2f9af1b9cfaa840d35f6737e086b8644a3796bedcf0cc/images/aW1hZ2UvcG5n/0544aa9080d7a1bd34f91fb6b907bd13.png" 
              alt="Start AI Right for Nonprofits Book Cover" 
              className="max-w-[240px] w-full h-auto shadow-2xl rounded-lg"
            />
          </div>
          <div className="w-full md:w-2/3">
            <span className="text-brand-gold font-bold text-sm uppercase tracking-widest mb-4 block">Built on practical experience</span>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">The foundation of our work</h2>
            <p className="text-gray-300 text-lg mb-8 leading-relaxed">
              The SAFE AI Framework is the foundation of <strong>Start AI Right for Nonprofits</strong>. The book gives leaders a practical roadmap for moving from informal AI use to a clear organisational approach.
            </p>
            <Button to="/book" variant="primary" className="bg-brand-gold text-brand-navy hover:bg-yellow-500 border-none font-bold">
              Learn more about the book
            </Button>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default BookSection;